import {LucideIcon} from 'lucide-react';
import {clsx} from 'clsx';

type IconBoxProps = {
  icon: LucideIcon;
  shape: 'circle' | 'square' | 'rounded' | 'rounded-full';
  size: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
};

export default function IconBox({
  icon: Icon,
  shape = 'rounded',
  size = 'md',
  className
}: IconBoxProps) {
  return (
    <div
      className={clsx(
        'inline-flex items-center justify-center',
        shape === 'circle' && 'rounded-full',
        shape === 'square' && 'rounded-none',
        shape === 'rounded' && 'rounded-md',
        shape === 'rounded-full' && 'rounded-full',
        size === 'xs' && 'h-6 w-6',
        size === 'sm' && 'h-8 w-8',
        size === 'md' && 'h-10 w-10',
        size === 'lg' && 'h-12 w-12',
        size === 'xl' && 'h-14 w-14',
        'bg-purple-100 dark:bg-purple-900/30',
        className
      )}
    >
      <Icon
        className={clsx(
          'text-purple-600 dark:text-purple-300',
          size === 'xs' && 'h-4 w-4',
          size === 'sm' && 'h-5 w-5',
          size === 'md' && 'h-6 w-6',
          size === 'lg' && 'h-7 w-7'
        )}
      />
    </div>
  );
}
